import { ApiResponse } from '@/models/ApiResponse';
import { ReportFile } from '@/models/ReportFile';
import {
  RunDealContingentPayload,
  SaveUserWidgetDealContingentPayload,
} from '@/pages/DealContingentAnalysis/store/types';
import { AxiosInstance, AxiosResponse } from 'axios';

export default class IRAnalysisAPI {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }
  async saveUserWidgetData(
    payload: SaveUserWidgetDealContingentPayload,
  ): Promise<AxiosResponse<ApiResponse<any>>> {
    return this.client.post('/v2/user/save-user-widget-data/', payload);
  }

  async runDealContingent(
    payload: RunDealContingentPayload,
  ): Promise<AxiosResponse<ApiResponse<ReportFile>>> {
    const url = '/v2/hedging/run-deal-contingent/';
    return this.client.post(url, payload);
  }
}
